import { useRecommendationTypes } from "./hooks/useRecommendationTypes";

export { useRecommendationTypes };
